import { IconButton, Snackbar } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { ReactNode } from 'react'

interface Props {
  open: boolean
  setOpen: (val: boolean) => void
  message: string | ReactNode
}

const ToastMessage = ({ open, setOpen, message }: Props) => {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      message={message}
      action={
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <Close className="close" fontSize="small" />
          </IconButton>
        </>
      }
    />
  )
}

export default ToastMessage
